import {
  setTitleAction,
  TitleFeature as titleReducer,
  TitlePayload,
} from '@smartsheet-dataflow/formjs';
import { BridgeFormJSState } from '../../Types';
import { dummyDispatch } from '../ParamFromSchema';

export const reduceTitle =
  (payload: TitlePayload) => (state: BridgeFormJSState) =>
    titleReducer(state, setTitleAction(dummyDispatch)(payload));
